import { Delete, Edit, Visibility } from "@mui/icons-material";
import {
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal } from "../../Components/Modal/Modals";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    DeleteVendorAction,
    GetAllVendors,
    resetVendors,
} from "../../Redux/VendorSlice/VendorSlice";
import StateVendorShow from "./StateVendorShow";

const AllVendors = () => {
    // Delete Vendor Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success(" Vendor deleted success");
        await GetAllVendorsMethod();
        await dispatch(resetVendors());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteVendorAction(data.id));
        await CallNotificationMethod();
        await setTableId(data.id);
    };
    const handelDeleteVendor = async (data) => {
        handleOpen(data);
    };
    const [showState, setShowState] = useState(0);
    const dispatch = useDispatch();
    const { vendors, isSuccess, isError, isLoading } = useSelector(
        (state) => state.vendors
    );
    const Vendors = vendors?.data?.data || [];
    const GetAllVendorsMethod = async () => {
        await dispatch(GetAllVendors());
        await dispatch(resetVendors());
    };
    useEffect(() => {
        GetAllVendorsMethod();
    }, []);

    const handelShowStateVendors = (id) => {
        id === showState ? setShowState(0) : setShowState(id);
    };

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        {/* <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell
                                    style={{ padding: "5px" }}
                                    width={500}
                                >
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            name="name"
                                            label="Name"
                                            value={name}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="address"
                                            name="address"
                                            label="Address"
                                            value={address}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setAddress(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="email"
                                            name="email"
                                            label="Email"
                                            value={email}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="company_name"
                                            name="company_name"
                                            label="Coname"
                                            value={company_name}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setConame(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="phone"
                                            name="phone"
                                            label="Phone"
                                            value={phone}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setPhone(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="rate"
                                            name="rate"
                                            label="Rate"
                                            value={rate}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setRate(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled> */}

                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {Vendors?.map((vendor, index) => (
                                <>
                                    <TableRowStyled key={vendor.id}>
                                        <TableCellStyle>
                                            {/* {rowsPerPage * page + index + 1} */}
                                            {index + 1}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {vendor.name}
                                        </TableCellStyle>

                                        <TableCellStyle align="center">
                                            <IconButton>
                                                <Link to={"edit=" + vendor.id}>
                                                    <Edit color="success" />
                                                </Link>
                                            </IconButton>
                                            <IconButton
                                                onClick={() =>
                                                    handelDeleteVendor(vendor)
                                                }
                                            >
                                                {tableId === vendor.id && (
                                                    <ProgressStyled>
                                                        <CircularProgress
                                                            size={30}
                                                            color="error"
                                                        />
                                                    </ProgressStyled>
                                                )}

                                                <ProgressStyled>
                                                    <Delete color="error" />
                                                </ProgressStyled>
                                            </IconButton>
                                            {vendor?.state_vendor && vendor?.state_vendor.length !== 0 && (
                                                
                                            <IconButton
                                            onClick={(e) =>
                                                handelShowStateVendors(
                                                    vendor.id
                                                )
                                            }
                                        >
                                            <Visibility color="primary" />
                                        </IconButton>
                                            )}
                                        </TableCellStyle>
                                    </TableRowStyled>
                                    {vendor.state_vendor &&
                                        showState === vendor.id && (
                                            <StateVendorShow
                                                states={vendor.state_vendor}
                                            ></StateVendorShow>
                                        )}
                                </>
                            ))}
                        </TableBody>

                        {/* {installerPag.total >= 20 && (
                            <TablePagination
                                rowsPerPageOptions={[
                                    installerPag.count,
                                    installerPag.count * 4,
                                    installerPag.count * 6,
                                    { label: "All", value: -1 },
                                ]}
                                colSpan={12}
                                count={installerPag.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )} */}
                    </Table>

                    {/* {installerPag.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )} */}
                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllVendors;
